import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { TabContainer } from '@holmescorp/base-widgets/tab-container';
import { Icon } from '@holmescorp/base-widgets/icon';
import { lccstate, createNlsMiddleware, tapaneChangeProcess, childmap, keymap, pathmap } from '@holmescorp/lcc-state';
import { difference } from '@holmescorp/collections';
import { contentTrack } from '../support/content';
import css from '../css/content-order.m.css';
const settings = createNlsMiddleware('settings');
const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, settings, nls, lccstate, contentTrack }).properties();
export const ContentOrder = factory(({ middleware: { theme, settings, nls, lccstate, contentTrack } }) => {
    const themeCss = theme.classes(css);
    const { get, path, run } = lccstate;
    const roots = get(path('ditaroots'));
    const tracking = get(path('tracking'));
    let keySet;
    if (tracking) {
        const expandKeys = new Set(get(path('accordionSelected')));
        const localKeys = new Set(childmap.get(tracking.topichead));
        keySet = [...difference(expandKeys, localKeys), ...[tracking.topicset]];
    }
    run(tapaneChangeProcess)({ accordionSelected: keySet ? keySet : contentTrack.openTopicsets() });
    const { messages: { is_demo = false, demo_allowed_roots = '[]' } } = settings();
    const { messages: { topic_domain_mappings = '{}' } } = nls();
    let allowed_roots = [];
    let domainMappings = {};
    try {
        allowed_roots = JSON.parse(demo_allowed_roots);
        domainMappings = JSON.parse(topic_domain_mappings);
    }
    catch (e) {
        console.warn(`json parse error ${e}`, demo_allowed_roots);
        console.warn(`json parse error ${e}`, topic_domain_mappings);
    }
    const getinitialActiveIndex = () => {
        return tracking ? roots.indexOf(tracking.topichead) : undefined;
    };
    const tablist = roots.map((root) => {
        const kidkeys = childmap.get(root) || [];
        const key = kidkeys[0] || '';
        const topic = {
            attributes: { key: `content-view` },
            children: kidkeys.map((tgf) => {
                const { path } = keymap.get(tgf);
                const { topic } = pathmap.get(path);
                return { ...topic };
            })
        };
        const { title: titleText = '' } = keymap.get(root) || {};
        const domainLabel = domainMappings[key] && domainMappings[key].useImage
            ? v('img', { classes: [themeCss.imgTitle], src: domainMappings[key].imageURL, alt: titleText })
            : titleText;
        const bookIcon = v('div', { classes: [themeCss.bookIcon] }, [
            v('span', { classes: ['fa-stack'] }, [
                v('i', { classes: ['fas', 'fa-circle', 'fa-stack-2x'] }),
                v('i', { classes: ['fas', 'fa-book', 'fa-stack-1x', 'fa-inverse'] }),
                w('TopicStatusIcon', { key: root, isBadge: true })
            ])
        ]);
        const lockIcon = v('span', { classes: [themeCss.lockIcon] }, [w(Icon, { faname: 'lock' })]);
        const open = v('span', { xqa: `domain ${root}`, classes: [themeCss.tabTitle, themeCss.titleOpen] }, [
            is_demo && allowed_roots.indexOf(root) === -1 ? lockIcon : null,
            bookIcon,
            domainLabel
        ]);
        const closed = v('span', { xqa: `domain ${root}`, classes: [themeCss.tabTitle, themeCss.titleClosed] }, [
            is_demo && allowed_roots.indexOf(root) === -1 ? lockIcon : null,
            bookIcon,
            domainLabel
        ]);
        return {
            key: root,
            closeable: false,
            title: { open, closed },
            content: w('TopicAccordion', { topic })
        };
    });
    const initialActiveIndex = getinitialActiveIndex();
    return v('div', { key: 'content-order', xqa: 'view content-order', classes: [themeCss.root] }, [
        w(TabContainer, { initialActiveIndex }, tablist)
    ]);
});
